import { useParams } from 'react-router-dom';

import { useGetWholesaleCustomerByIdQuery } from '@/features/slice/wholesale-admin/wholesale-admin.api-slice';

import { useGetOrderByCustomerIdQuery } from '../../../features/slice/order';

export const useWholesaleCustomerDetails = () => {
    const params = useParams();
    const { id } = (params as { id: string }) ?? {};

    const { data, isLoading, isError } = useGetWholesaleCustomerByIdQuery(id);

    console.log('Wholesale Customer Details Data:', data);

    const {
        data: dueOrders,
        isLoading: isLoadingOrders,
        isError: isErrorOrders,
    } = useGetOrderByCustomerIdQuery(id);

    return {
        data,
        isLoading,
        isError,
        dueOrders,
        isLoadingOrders,
        isErrorOrders,
    };
};
